<script>
import { mapState, mapGetters } from 'vuex'
import { pricingMixin } from '../../mixins/pricingMixin'
import ChallengeSubscriptionCard from '@components/challenge-purchase/challenge-subscription-card.vue'
import isEmpty from 'lodash/isEmpty'
import Translate from '@components/translate'

export default {
  props: {
    selectedSubscription: {
      type: Object,
      required: true,
      default: () => {}
    },
    isAnnualSelected: {
      type: Boolean,
      required: true,
      default: false
    },
    fullPrice: {
      type: Number,
      required: false,
      default: 0
    }
  },
  components: {
    ChallengeSubscriptionCard,
    Translate
  },
  mixins: [pricingMixin],
  data () {
    return {}
  },
  mounted () {},
  computed: {
    ...mapState(['settings', 'subscriptions', 'user']),
    ...mapGetters(['primaryColorRgb', 'activeChallenge', 'activeSubscription', 'hasNativeSubscription', 'hasActiveNativeSubscription']),
    siteName () {
      return this.settings && this.settings.siteName && this.settings.siteName
    },
    goodToUpgrade () {
      return (this.activeChallenge &&
        this.activeChallenge.metadata &&
        this.activeChallenge.metadata.freeWithAnnual) &&
        ((this.activeSubscription &&
        this.activeSubscription.plan &&
        this.activeSubscription.plan.interval &&
        this.activeSubscription.plan.interval !== 'year') ||
        (this.hasNativeSubscription && this.hasActiveNativeSubscription &&
        this.user.profile.subscription_plan_type && (!this.user.profile.subscription_plan_type.includes('year') || !this.user.profile.subscription_plan_type.includes('annual') || !this.user.profile.subscription_plan_type.includes('anual'))))
    },
    title () {
      if (this.goodToUpgrade) {
        return 'challenge.purchase.step2.title.goodToUpgrade'
      } else {
        if (
          ((this.activeSubscription && this.activeSubscription.plan && this.activeSubscription.plan.interval !== 'year') || (this.hasNativeSubscription && this.hasActiveNativeSubscription && this.user.profile.subscription_plan_type && !this.user.profile.subscription_plan_type.includes('annual')))
        ) {
          return 'challenge.purchase.step2.title.timeToUpgrade'
        } else {
          return 'challenge.purchase.step2.title.default'
        }
      }
    },
    buttonEnabled () {
      if (
        (this.selectedSubscription && this.selectedSubscription.id) ||
        ((this.activeSubscription && this.activeSubscription.plan) || (this.hasNativeSubscription && this.hasActiveNativeSubscription))
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    priceInterval (plan) {
      const interval = plan.interval
      const intervalCount = plan.interval_count
      if (interval === 'year') { return 'Annually' }
      if (interval === 'month') { if (intervalCount === 1) { return 'Monthly' } if (intervalCount === 3) { return 'Quarterly' } }
      if (interval === 'week') { return 'Weekly' }
      if (interval === 'day') { return 'Daily' } else {
        return ''
      }
    },
    isCurrent (plan) {
      if ((
        this.activeSubscription &&
        this.activeSubscription.plan &&
        this.activeSubscription.plan.interval === plan.interval && this.activeSubscription.plan.interval_count === plan.interval_count) ||
        (this.hasNativeSubscription && this.hasActiveNativeSubscription &&
          this.user.profile.subscription_plan_type && this.user.profile.subscription_plan_type.includes(this.priceInterval(plan).toLowerCase()))) {
        return true
      } else {
        if (this.hasNativeSubscription && this.hasActiveNativeSubscription && this.user.profile.subscription_plan_type && this.priceInterval(plan).toLowerCase() === 'annually') {
          if (this.user.profile.subscription_plan_type.includes('year')) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    isSelected (plan) {
      if (this.selectedSubscription && !isEmpty(this.selectedSubscription)) {
        return this.selectedSubscription.interval === plan.interval && this.selectedSubscription.interval_count === plan.interval_count
      } else {
        return this.isCurrent(plan)
      }
    }
  }
}
</script>

<template>
  <div class="container--payment-form" :style="{ '--PrimaryColor': `rgba(${primaryColorRgb}, ${1})` }">
    <div class="text-center">
      <p class="step-indicator"><Translate directive="challenge.purchase.step2.step" /></p>
      <div class="title-section">
        <h3 class="title"><Translate :directive="title" /></h3>
      </div>
      <template v-for="plan in subscriptions[0].plans">
        <ChallengeSubscriptionCard
          :hideSubscribedFlag="false"
          :key="plan.id"
          :subscription="plan"
          :isSelected="isSelected(plan)"
          @select-price="$emit('set-subscription', plan)"
          :noSub="false"
          :fromChallenge="true"
        />
      </template>
      <div v-if="goodToUpgrade && hasActiveNativeSubscription" class="iap-warning">
        <Translate directive="challenge.purchase.step2.goodToUpgradeNote" />
      </div>
    </div>
    <div class="footer">
        <div v-if="goodToUpgrade && (activeSubscription || (hasNativeSubscription && hasActiveNativeSubscription)) && !hasActiveNativeSubscription" class="upgrade-callout">
          <Translate directive="challenge.purchase.step2.upgradeCalloutNote" />
        </div>
        <div class="lower-section">
          <div class=text>
            <p><Translate directive="challenge.purchase.step2.notes1" /></p>
            <p><Translate directive="challenge.purchase.step2.notes2" /></p>
          </div>
          <b-button
          class="button-next"
          @click="$emit('next')"
          :disabled="!buttonEnabled"
          >
            <span><Translate directive="challenge.purchase.step2.checkoutButton" /></span>
          </b-button>
        </div>
      </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.container--payment-form {
  padding-top: 70px;
  padding-bottom: 80px;
  .step-indicator {
    font-size: 17px;
    font-weight: 400;
    color: #9E9E9E;
    margin-bottom: 0;
    line-height: 0.5rem;
  }
  .title-section {
    .new-user {
      font-family: $base-font-family;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 32px;
      text-align: center;
      color: #000000;
      opacity: 0.5;
      width: 80%;
      margin-left: auto;
      margin-right: auto;
      @media screen and (max-width: 700px) {
        font-size: 20px;
        line-height: 27px;
        padding: unset;
        width: 100%;
      }
    }
    h3 {
      margin-bottom: 8px !important;
      &.title {
        margin-top: 10px;
        padding: 0 20px;
        font-family: 'Roboto', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 40px;
        line-height: 47px;
        text-align: center;
        @media screen and (max-width: 700px) {
          font-size: 25px;
          line-height: 32px;
          padding: unset;
        }
      }
    }
    @media screen and (max-width: 700px) {
      min-height: 7rem;
    }
  }
}
.iap-warning {
    text-align: center;
    font-weight: bold;
    color: $color-error-dark;
  }

.footer {
  position: absolute;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  bottom: 0;
  left: 0;
  right: 0;
  .upgrade-callout {
    font-family: $base-font-family;
    font-style: normal;
    font-weight: bold;
    font-size: 19px;
    line-height: 26px;
    text-align: center;
    color: var(--PrimaryColor);
    width: 75%;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 15px;
  }
  .lower-section {
    border-top: 1px solid rgba(0, 0, 0, 0.125);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px 14px;
    background-color: white;
    border-radius: 0 0 24px 24px;
    .text {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;
      p {
        margin-bottom: unset;
        &:first-child {
          font-family: $base-font-family;
          font-style: normal;
          font-weight: bold;
          font-size: 17px;
          line-height: 22px;
          color: #000000;
        }
        &:nth-child(2) {
          font-family: $roboto-font-family;
          font-style: normal;
          font-weight: normal;
          font-size: 17px;
          line-height: 22px;
          text-align: center;
          color: #000000;
          opacity: 0.5;
        }
      }
    }
    .button-next {
      border-radius: 2rem;
      background-color: black;
      padding: 0.6rem 2.2rem;
      min-height: unset;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 23px;
      text-transform: capitalize;
      border: 2px black solid;
      letter-spacing: 0.1px;
      position: relative;
      &:disabled {
        background-color: rgba(#2F2E2E, 0.7);
        border: 2px rgba(#2F2E2E, 0) solid;
        color: white;
      }
      &:hover {
        &:not(:disabled) {
          background-color: white;
          color: black;
          border: 2px black solid;
        }
      }
    }
  }
  @media screen and (max-width: 700px) {
    .upgrade-callout {
      width: 100%;
      font-size: 15px;
      line-height: 21px;
    }
    .lower-section {
       .text {
          margin-top: 14px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-end;
          p {
            &:first-child {
              font-size: 14px;
              line-height: 20px;
              margin-bottom: 3px;
            }
            &:nth-child(2) {
              font-family: $roboto-font-family;
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 17px;
              text-align: start;
              color: #000000;
              opacity: 0.5;
            }
          }
        }
       .button-next {
         margin-top: 10px;
         padding: 0.3rem 1.2rem;
       }
    }
  }
}
</style>
